import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const PopupWrapper = styled.div(({ theme }) => ({
  width: '100%',
  maxWidth: 335,
  textAlign: 'center',
  borderRadius: 8,
  overflow: 'hidden',
  boxShadow: theme.elevation[5],

  [`${theme.mediaBreakpointUp.md}`]: {
    maxWidth: 480,
  },
}));

export const PopupHeader = styled.div(({ theme }) => ({
  position: 'relative',
  background: theme.colors.darkBlue,
  height: theme.spacing[40],
}));

export const PopupContentWrapper = styled.div(({ theme }) => ({
  background: theme.colors.highEmphasisWhite,
  padding: `${theme.spacing[40]} ${theme.spacing[20]}`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  [`${theme.mediaBreakpointUp.md}`]: {
    padding: theme.spacing[40],
  },
}));

export const Title = styled(Typography).attrs({
  variant: TextStyles['Heading 2'],
  type: 'p',
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
  marginBottom: theme.spacing[4],
  wordBreak: 'break-word',
}));

export const Subcopy = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
  marginBottom: theme.spacing[24],
  wordBreak: 'break-word',
}));
